import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import { TabWrapper, TabImpl, TabInner } from "./tab.styles.es.js";
import { tabsContext } from "./tabs-context.es.js";
import "@reach/auto-id";
import "lodash/fp";
import { useHandler } from "../../hooks/use-handler.es.js";
import "styled-components";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  onEntered: PropTypes.func,
  tabKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.node
};
const defaultProps = {
  as: void 0,
  children: void 0,
  onEntered: void 0,
  title: void 0
};
const Tab = forwardRef(
  ({ as, children, onEntered, tabKey, title, ...restProps }, ref) => {
    const [activeKey, setActiveKey] = useContext(tabsContext);
    const handleClick = useHandler((event) => {
      if (!event.defaultPrevented) {
        setActiveKey(tabKey);
      }
    });
    const handleKeyDown = useHandler((event) => {
      if (event.key === "Enter") {
        setActiveKey(tabKey);
      }
    });
    return /* @__PURE__ */ jsxs(TabWrapper, { children: [
      /* @__PURE__ */ jsx(
        TabImpl,
        {
          ref,
          as,
          id: `tab--${tabKey}`,
          onClick: handleClick,
          onKeyDown: handleKeyDown,
          selected: tabKey === activeKey,
          ...restProps,
          children: title ? /* @__PURE__ */ jsx(TabInner, { hasMenu: Boolean(children), children: title }) : children
        }
      ),
      title && children
    ] });
  }
);
Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
export {
  Tab
};
